<template>
  <div class="headerCabinet">
    <div class="head-1">
      <!-- <p>
        SLT: <span>{{ profile.bonus }}</span>
      </p> -->
      <p>
         {{$t('bonuse')}}: <span>{{ profile.bonus_1c }}</span>
      </p>
      <p>
       {{$t('status')}}: <span>{{ profile.bonus_category }}</span>
      </p>
    </div>
    <div class="head-2">
      <div class="language">
        <div class="dropdown">
          <button
            class="dropdown-toggle"
            type="button"
            id="menu1"
            data-toggle="dropdown"
          >
            <span v-if="selectedLang == 'ru'">Рус</span> <span v-if="selectedLang == 'kz'">Қаз</span> <span class="caret"></span>
          </button>
          <ul class="dropdown-menu" role="menu" aria-labelledby="menu1">
            <li role="presentation" v-if="selectedLang == 'ru'" @click="selectLang('kz')">
              <a role="menuitem" tabindex="-1" href="#">Каз</a>
            </li>
            <li role="presentation" v-if="selectedLang == 'kz'" @click="selectLang('ru')">
              <a role="menuitem" tabindex="-1" href="#">Рус</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="name">{{ profile.firstname }} {{ profile.lastname }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "headerCabinet",
  data() {
    return {
      profile: "",
      selectedLang: this.$auth.getLanguage(),
      lang: [],
    };
  },
  created() {
    this.profile = JSON.parse(localStorage.getItem("user"));
  },
  methods: {
    selectLang(lng) {
            if (lng === 'ru') {
              this.$auth.setLanguage(lng);
              location.reload();
            } else if (lng === 'kz') {
              this.$auth.setLanguage(lng)
              location.reload();
            }
          },
              setLanguage(lang) {
      this.$auth.setLanguage(lang);
      location.reload();
    },
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/cabinet/headerCabinet.vue